var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9997 21V14.3333C23.9997 10.24 21.8263 6.81333 17.9997 5.90667V5C17.9997 3.89333 17.1063 3 15.9997 3C14.893 3 13.9997 3.89333 13.9997 5V5.90667C10.1863 6.81333 7.99967 10.2267 7.99967 14.3333V21L5.33301 23.6667V25H26.6663V23.6667L23.9997 21ZM15.9997 29C17.4663 29 18.6663 27.8 18.6663 26.3333H13.333C13.333 27.8 14.533 29 15.9997 29ZM10.6663 22.3333H21.333V14.3333C21.333 11.0267 19.3197 8.33333 15.9997 8.33333C12.6797 8.33333 10.6663 11.0267 10.6663 14.3333V22.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.6c947bb011d3fb66116e22f63b1ae76a.svg";
export { ForwardRef as ReactComponent };